/**
 * Pure permission check (no app imports) so it can run in Node tests as well
 * as in the browser. See permissions.js for the action-letter mapping.
 */
export function can(permissions, group, action = 'X') {
  const grant = permissions?.[group]
  if (!grant) return false
  switch (action) {
    case 'X': return !!grant.view
    case 'C': return !!grant.create
    case 'G': return !!(grant.create || grant.update)
    case 'P': return !!grant.update
    case 'D': return !!grant.delete
    default: return false
  }
}

/** Named helpers (same semantics as the action letters). */
export const canCreate = (permissions, group) => can(permissions, group, 'C')
export const canUpdate = (permissions, group) => can(permissions, group, 'P')
